import ReactGA from 'react-ga4';

export const trackEvent = (name, params) => {
  if (process.env.NODE_ENV === 'production') ReactGA.event(name, params);
};

export const setUserProperties = params => {
  ReactGA.gtag('set', 'user_properties', params);
};
